export function isValidEmployeePassword(password: string): boolean {
    return !isNaN(password as any) && /^\d{4}$/.test(password);
}
